exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper {\n  width: 100%;\n  font-size: 10px; }\n  .wrapper .footer-top {\n    width: 100%;\n    background: #ddab55; }\n    .wrapper .footer-top .container {\n      width: 100%;\n      padding: 7px 20px; }\n      .wrapper .footer-top .container .line_wrapper img {\n        margin-right: 10px; }\n      .wrapper .footer-top .container .line_wrapper .pointer {\n        cursor: pointer; }\n      .wrapper .footer-top .container .line_wrapper p {\n        color: rgba(255, 255, 255, 0.96);\n        margin: 0 !important;\n        font-size: 10px; }\n        @media only screen and (max-width: 780px) {\n          .wrapper .footer-top .container .line_wrapper p {\n            margin: 7px 0px !important; } }\n      .wrapper .footer-top .container .link {\n        text-decoration: none;\n        color: rgba(255, 255, 255, 0.96); }\n  .wrapper .bottom {\n    width: 100%;\n    height: 34px;\n    background: white; }\n    .wrapper .bottom .container {\n      width: 100%;\n      max-width: 1480px; }\n      .wrapper .bottom .container p {\n        color: #777777;\n        margin: 7px 0px;\n        font-size: 10px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/app-root/src/src/app/components/footer/footer.component.scss
// module id = ../../../../../src/app/components/footer/footer.component.scss
// module chunks = main